/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Timeline_Legacy_Refresh_TitleInputs */



/**
* | output |
* | --- |
* | "Refresh Timeline" |
*
* @param {Timeline_Legacy_Refresh_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const timeline_legacy_refresh_title = /** @type {((inputs?: Timeline_Legacy_Refresh_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Timeline_Legacy_Refresh_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Actualiser la chronologie")
	if (locale === "de") return /** @type {LocalizedString} */ ("Zeitleiste aktualisieren")
	if (locale === "it") return /** @type {LocalizedString} */ ("Aggiorna cronologia")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Обновить временную шкалу")
	if (locale === "es") return /** @type {LocalizedString} */ ("Actualizar la línea de tiempo")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("刷新时间线")
	if (locale === "ja") return /** @type {LocalizedString} */ ("タイムラインを更新")
	if (locale === "hi") return /** @type {LocalizedString} */ ("टाइमलाइन रीफ़्रेश करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Atualizar linha do tempo")
	return /** @type {LocalizedString} */ ("Refresh Timeline")
});